export default __webpack_public_path__ + "static/blue-footer-68c206d6dc318048b1ecc572ad50bcd0.png";